var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 6.5C3.33325 5.09987 3.33325 4.3998 3.60574 3.86502C3.84542 3.39462 4.22787 3.01217 4.69828 2.77248C5.23306 2.5 5.93312 2.5 7.33325 2.5H12.6666C14.0667 2.5 14.7668 2.5 15.3016 2.77248C15.772 3.01217 16.1544 3.39462 16.3941 3.86502C16.6666 4.3998 16.6666 5.09987 16.6666 6.5V17.5L14.3749 15.8333L12.2916 17.5L9.99992 15.8333L7.70825 17.5L5.62492 15.8333L3.33325 17.5V6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.6cdbae573f05d376b8ca05a330af55d3.svg";
export { ForwardRef as ReactComponent };